// Generated by CoffeeScript 1.11.1
(function() {
  var LAYER_INFO, LazyExecute, Util,
    hasProp = {}.hasOwnProperty;

  LazyExecute = require('../lazy_execute');

  Util = require('../util');

  LAYER_INFO = {
    artboard: require('../layer_info/artboard'),
    blendClippingElements: require('../layer_info/blend_clipping_elements'),
    blendInteriorElements: require('../layer_info/blend_interior_elements'),
    fillOpacity: require('../layer_info/fill_opacity'),
    gradientFill: require('../layer_info/gradient_fill'),
    layerId: require('../layer_info/layer_id'),
    layerNameSource: require('../layer_info/layer_name_source'),
    legacyTypetool: require('../layer_info/legacy_typetool'),
    locked: require('../layer_info/locked'),
    metadata: require('../layer_info/metadata'),
    name: require('../layer_info/unicode_name'),
    nestedSectionDivider: require('../layer_info/nested_section_divider'),
    objectEffects: require('../layer_info/object_effects'),
    sectionDivider: require('../layer_info/section_divider'),
    solidColor: require('../layer_info/solid_color'),
    typeTool: require('../layer_info/typetool'),
    vectorMask: require('../layer_info/vector_mask'),
    vectorOrigination: require('../layer_info/vector_origination'),
    vectorStroke: require('../layer_info/vector_stroke'),
    vectorStrokeContent: require('../layer_info/vector_stroke_content')
  };

  module.exports = {
    parseLayerInfo: function() {
      var i, key, keyParseable, klass, length, name, pos, results;
      results = [];
      while (this.file.tell() < this.layerEnd) {
        this.file.seek(4, true);
        key = this.file.readString(4);
        length = Util.pad2(this.file.readInt());
        pos = this.file.tell();
        keyParseable = false;
        for (name in LAYER_INFO) {
          if (!hasProp.call(LAYER_INFO, name)) continue;
          klass = LAYER_INFO[name];
          if (!klass.shouldParse(key)) {
            continue;
          }
          i = new klass(this, length);
          this.adjustments[name] = new LazyExecute(i, this.file).now('skip').later('parse').get();
          if (this[name] == null) {
            (function(_this) {
              return (function(name) {
                return _this[name] = function() {
                  return _this.adjustments[name];
                };
              });
            })(this)(name);
          }
          this.infoKeys.push(key);
          keyParseable = true;
          break;
        }
        if (!keyParseable) {
          results.push(this.file.seek(length, true));
        } else {
          results.push(void 0);
        }
      }
      return results;
    }
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer/info.js
// module id = 51
// module chunks = 0